export default __webpack_public_path__ + "static/media/38t.0698dd9a.jpg";